module.exports = __webpack_public_path__ + "s/img/Glam_D_2.e708a191.jpg";